export { default } from "./ownerDocument.js";